import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { NotificationApi } from 'api';
import { genNameListActivityType } from 'utils/function';

export const findNotification = createAsyncThunk(
  'notification/findNotification',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await NotificationApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findNotificationForLinkedTab = createAsyncThunk(
  'notification/findNotificationForLinkedTab',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await NotificationApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findNotificationForSystemTab = createAsyncThunk(
  'notification/findNotificationForSystemTab',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await NotificationApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findNotificationForOrderTab = createAsyncThunk(
  'notification/findNotificationForOrderTab',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await NotificationApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findNotificationForRequestTab = createAsyncThunk(
  'notification/findNotificationForRequestTab',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await NotificationApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const getNotificationCount = createAsyncThunk(
  'notification/getNotificationCount',
  async (optiton: any, { rejectWithValue }) => {
    try {
      const response = await NotificationApi.getCount(optiton);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createNotification = createAsyncThunk(
  'notification/createNotification',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await NotificationApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateNotificationStatus = createAsyncThunk(
  'notification/updateNotificationStatus',
  async (param: any, { rejectWithValue }) => {
    const { id, body, activityType } = param;
    try {
      const response: any = await NotificationApi.updateStatus(id, body);

      return { response, id, activityType };
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeNotification = createAsyncThunk(
  'notification/removeNotification',
  async (params: any, { rejectWithValue }) => {
    const { id, activityType } = params;
    try {
      const response: any = await NotificationApi.remove(id);
      return { response, id, activityType };
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  linkedList: Array<any>;
  systemList: Array<any>;
  orderList: Array<any>;
  requestList: Array<any>;
  tab: 'overview' | 'linked' | 'system' | 'order' | 'request';
  count: number;
}

const initialState: IState = {
  list: [],
  linkedList: [],
  systemList: [],
  orderList: [],
  requestList: [],
  tab: 'overview',
  count: 0,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setCurrentTab(state, action) {
      const newTab = action.payload;
      state.tab = newTab;
    },
    addNotiItem(state, action) {
      const notiItem = action.payload;
      const nameList = genNameListActivityType(notiItem.activityType);
      state.list = [notiItem].concat(state.list);
      state[nameList] = [notiItem].concat(state[nameList]);
      state.count += 1;
    },
    decreaseCount(state) {
      state.count -= 1;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(findNotification.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.count = 0;
        state.list = data;
      })
      .addCase(findNotificationForLinkedTab.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.linkedList = data;
      })
      .addCase(findNotificationForSystemTab.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.systemList = data;
      })
      .addCase(findNotificationForOrderTab.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.orderList = data;
      })
      .addCase(findNotificationForRequestTab.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.requestList = data;
      })
      .addCase(getNotificationCount.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.count = data.size;
      })
      .addCase(updateNotificationStatus.fulfilled, (state, action) => {
        const { response, id, activityType } = action.payload;
        const nameList = genNameListActivityType(activityType);
        if (response?.code === 200) {
          const newList = [...state.list];
          const index = newList.findIndex(item => item.id === id);
          const newItem = newList[index];
          newItem.status = 2;
          newList.splice(index, 1, newItem);
          state.list = newList;

          if (nameList !== '') {
            const newTabList = [...state[nameList]];
            if (newTabList.length > 0) {
              const indexTab = newTabList.findIndex(item => item.id === id);
              const newItemTab = newTabList[indexTab];
              newItemTab.status = 2;
              newTabList.splice(indexTab, 1, newItemTab);
              state[nameList] = newTabList;
            }
          }
        }
      })
      .addCase(removeNotification.fulfilled, (state, action) => {
        const { response, id, activityType } = action.payload;
        if (response?.code === 200) {
          state.list = state.list.filter(item => item.id !== id);
          const nameList = genNameListActivityType(activityType);
          state[nameList] = state[nameList].filter(item => item.id !== id);
        }
      });
  },
});

const { actions, reducer: notificationReducer } = notificationSlice;

export const { addNotiItem, setCurrentTab, decreaseCount } = actions;

export default notificationReducer;
